// This file is auto-generated by scripts/codegen.ts
// Do not edit manually. Run `pnpm codegen` to regenerate.

export const bold = {
  id: 'bold',
  name: 'Bold',
  contexts: ["v1","v2"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as {},
} as const

export const clinicianSearchSubmitted = {
  id: 'clinician_search_submitted',
  name: 'Clinician Search Submitted',
  contexts: ["arc"] as const,
  backends: {"amplitude":{"nonPHIKeys":["search_text_length","total_count"]},"datadog":true},
  deduplicate: false,
  fields: {} as { text: string; search_text_length: number; total_count: number },
} as const

export const cliniciansPageDisplayed = {
  id: 'clinicians_page_displayed',
  name: 'Clinicians Page Displayed',
  contexts: ["arc"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { full_load_duration_ms: number; source: 'primary_navigation' | 'direct'; count_clinicians_loaded: number; total_count: number; page_number: number; from: string; to: string },
} as const

export const cliniciansPageSwitched = {
  id: 'clinicians_page_switched',
  name: 'Clinicians Page Switched',
  contexts: ["arc"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { origin_page: number; destination_page: number },
} as const

export const conditionDetailDisplayed = {
  id: 'condition_detail_displayed',
  name: 'Condition Detail Displayed',
  contexts: ["arc"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { condition_title: string; icd10_code: string; has_history: boolean; has_clinical_evidence: boolean },
} as const

export const conditionsCopied = {
  id: 'conditions_copied',
  name: 'Conditions Copied',
  contexts: ["moose"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { full_note_copy: boolean; regard_generated_note_id: string | null; conditions: { name: string; code: string; source: string | null }[] },
} as const

export const conditionsDisplayed = {
  id: 'conditions_displayed',
  name: 'Conditions Displayed',
  contexts: ["moose"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { conditions: { name: string; code: string; source: string | null }[]; regard_generated_note_id: string | null },
} as const

export const displayedColumnsChanged = {
  id: 'displayed_columns_changed',
  name: 'Displayed Columns Changed',
  contexts: ["arc"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { page: 'patients' | 'patient' | 'clinicians'; section: 'patients' | 'conditions' | 'clinicians'; type: 'add' | 'remove'; value: string },
} as const

export const filterChanged = {
  id: 'filter_changed',
  name: 'Filter Changed',
  contexts: ["arc"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { page: 'patients' | 'patient' | 'clinicians'; section: 'patients' | 'conditions' | 'clinicians'; detail: 'status' | 'final_bill' | 'drg_opportunity' | 'drg_regard_added' | 'has_condition' | 'tier' | 'first_identified_by' | 'note_status' | 'specialty' | 'facility' | 'launched_regard'; value: string; type: 'add' | 'remove' | 'replace'; previous_value: string | null; method: 'control' | 'chip' | 'clear_all' },
} as const

export const firstUserInteractionRecorded = {
  id: 'first_user_interaction_recorded',
  name: 'First User Interaction Recorded',
  contexts: ["moose","atlas"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: true,
  fields: {} as { interaction_type: 'click' | 'drag' | 'hover' | 'scroll' | 'type' | 'mouse_movement' },
} as const

export const formatNote = {
  id: 'formatNote',
  name: 'Format Titles',
  contexts: ["v1","v2"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { format: string },
} as const

export const italic = {
  id: 'italic',
  name: 'Italic',
  contexts: ["v1","v2"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as {},
} as const

export const mooseChatAiEditedNote = {
  id: 'moose_chat_ai_edited_note',
  name: 'Chat - AI Edited Note',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["chat_id"]},"datadog":true},
  deduplicate: false,
  fields: {} as { chat_id: string },
} as const

export const mooseChatAiResponded = {
  id: 'moose_chat_ai_responded',
  name: 'Chat - AI Responded',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["chat_id","response_type","conversation_id","turn_index"]},"datadog":true},
  deduplicate: false,
  fields: {} as { chat_id: string; response_type: 'query_response' | 'note_generation' | 'note_edit' | 'settings_update'; conversation_id?: string; turn_index?: number },
} as const

export const mooseChatCopiedAiResponse = {
  id: 'moose_chat_copied_ai_response',
  name: 'Chat - Copied AI Response',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["chat_id","conversation_id","turn_index"]},"datadog":true},
  deduplicate: false,
  fields: {} as { chat_id: string; conversation_id?: string; turn_index?: number },
} as const

export const mooseChatDislikedAiResponse = {
  id: 'moose_chat_disliked_ai_response',
  name: 'Chat - Disliked AI Response',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["chat_id","conversation_id","turn_index"]},"datadog":true},
  deduplicate: false,
  fields: {} as { chat_id: string; conversation_id?: string; turn_index?: number },
} as const

export const mooseChatLikedAiResponse = {
  id: 'moose_chat_liked_ai_response',
  name: 'Chat - Liked AI Response',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["chat_id","conversation_id","turn_index"]},"datadog":true},
  deduplicate: false,
  fields: {} as { chat_id: string; conversation_id?: string; turn_index?: number },
} as const

export const mooseChatSettingsEditCanceled = {
  id: 'moose_chat_settings_edit_canceled',
  name: 'Chat - User Canceled Editing Settings',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["chat_id"]},"datadog":true},
  deduplicate: false,
  fields: {} as { chat_id: string },
} as const

export const mooseChatSettingsEditCompleted = {
  id: 'moose_chat_settings_edit_completed',
  name: 'Chat - User Completed Editing Settings',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["chat_id","note_types","instruction_action","instruction_added","settings_edited","regenerations"]},"datadog":true},
  deduplicate: false,
  fields: {} as { chat_id: string; note_types: string[]; instruction_action?: 'add' | 'edit' | 'remove'; settings_added: string[]; settings_deleted: string[]; instruction_added: boolean; settings_edited: string[]; regenerations: number },
} as const

export const mooseChatUserPrompted = {
  id: 'moose_chat_user_prompted',
  name: 'Chat - User Prompted',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["chat_id","chat_context","conversation_id","turn_index"]},"datadog":true},
  deduplicate: false,
  fields: {} as { chat_id: string; chat_context: 'moose_homepage' | 'chat_only' | 'note_draft'; conversation_id: string; turn_index: number },
} as const

export const mooseCitationHovered = {
  id: 'moose_citation_hovered',
  name: 'Citation - Hovered',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["surface","hover_duration_ms","cards_seen","source_count","regard_generated_note_id"]},"datadog":true},
  deduplicate: false,
  fields: {} as { surface: 'editor' | 'chat'; hover_duration_ms: number; cards_seen: number; source_count: number; regard_generated_note_id: string | null },
} as const

export const mooseDefaultSettingEdited = {
  id: 'moose_default_setting_edited',
  name: 'Edited a Default Setting',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["note_type","context","note_button_label"]},"datadog":true},
  deduplicate: false,
  fields: {} as { note_type: string; context: 'admin_onboarding' | 'user_onboarding' | 'note_level_user_onboarding' | 'user_settings_page' | 'admin_settings_page' | 'max_chat'; note_button_label: string | null },
} as const

export const mooseGlobalSettingEdited = {
  id: 'moose_global_setting_edited',
  name: 'Edited a Global Setting',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["setting","context"]},"datadog":true},
  deduplicate: false,
  fields: {} as { setting: string; context?: 'max_chat' },
} as const

export const mooseHomepageButtonClicked = {
  id: 'moose_homepage_button_clicked',
  name: 'Moose Homepage Button Clicked',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["button_name","note_type"]},"datadog":true},
  deduplicate: false,
  fields: {} as { button_name: string; note_type: string },
} as const

export const mooseLandingDisplayed = {
  id: 'moose_landing_displayed',
  name: 'Moose Landing Displayed',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["duration_ms","full_load_duration_ms"]},"datadog":true},
  deduplicate: true,
  fields: {} as { duration_ms: number; full_load_duration_ms: number | null },
} as const

export const mooseMaxChatDataReady = {
  id: 'moose_max_chat_data_ready',
  name: 'Max Chat Data Ready',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["chat_id","is_refresh","duration_ms","since_landing_displayed_ms"]},"datadog":true},
  deduplicate: false,
  fields: {} as { chat_id: string; is_refresh: boolean; duration_ms: number; since_landing_displayed_ms: number },
} as const

export const mooseNoteAnalyzed = {
  id: 'moose_note_analyzed',
  name: 'Analyzed a Note',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["note_type","context","note_button_label","origin"]},"datadog":true},
  deduplicate: false,
  fields: {} as { note_type: string; context: 'admin_onboarding' | 'user_onboarding' | 'user_settings_page' | 'admin_settings_page'; note_button_label: string | null; origin: 'chosen' | 'pasted' | null },
} as const

export const mooseNoteGenerationCompleted = {
  id: 'moose_note_generation_completed',
  name: 'Moose Note Generation Completed',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["entry_mode","note_type","base_note_type","base_note_identifier","duration_ms","first_chunk_ms","outcome","terminal","complete_received","accumulated_chars"]},"datadog":true},
  deduplicate: false,
  fields: {} as { entry_mode: 'ask' | 'generate'; note_type: string; base_note_type: 'note' | 'pasted' | 'draft' | null; base_note_identifier: string | null; duration_ms: number; first_chunk_ms: number | null; outcome: 'success' | 'error'; terminal: 'complete' | 'stream_ended_without_complete' | 'error'; complete_received: boolean; accumulated_chars: number | null; truncation_tail: string | null },
} as const

export const mooseNoteLevelOnboardingRegeneratedNote = {
  id: 'moose_note_level_onboarding_regenerated_note',
  name: 'Note Level Onboarding - Regenerated Note',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["note_type","is_existing_user"]},"datadog":true},
  deduplicate: false,
  fields: {} as { note_type: string; is_existing_user: boolean },
} as const

export const mooseNoteLevelOnboardingSaved = {
  id: 'moose_note_level_onboarding_saved',
  name: 'Note Level Onboarding - Saved',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["note_type","has_edits","regenerations","is_existing_user"]},"datadog":true},
  deduplicate: false,
  fields: {} as { note_type: string; has_edits: boolean; regenerations: number; is_existing_user: boolean },
} as const

export const mooseNoteLevelOnboardingStarted = {
  id: 'moose_note_level_onboarding_started',
  name: 'Note Level Onboarding - Started',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["note_type","has_prelearned","is_existing_user"]},"datadog":true},
  deduplicate: false,
  fields: {} as { note_type: string; has_prelearned: boolean; is_existing_user: boolean },
} as const

export const mooseNoteStreamTruncated = {
  id: 'moose_note_stream_truncated',
  name: 'Moose Note Stream Truncated',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["note_type","base_note_type","attempt_duration_ms","first_chunk_ms","accumulated_chars"]},"datadog":true},
  deduplicate: false,
  fields: {} as { note_type: string; base_note_type: 'note' | 'pasted' | 'draft' | null; attempt_duration_ms: number; first_chunk_ms: number | null; accumulated_chars: number | null; truncation_tail: string | null },
} as const

export const mooseOldVersionClicked = {
  id: 'moose_old_version_clicked',
  name: 'Clicked Old Version',
  contexts: ["moose"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as {},
} as const

export const mooseOnboardingCompleted = {
  id: 'moose_onboarding_completed',
  name: 'Onboarding - Completed',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["type","completion_method","is_skipped"]},"datadog":true},
  deduplicate: false,
  fields: {} as { type: 'admin' | 'user'; completion_method: 'get_started' | 'go_to_settings'; is_skipped: boolean },
} as const

export const mooseOnboardingStarted = {
  id: 'moose_onboarding_started',
  name: 'Onboarding - Started',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["type"]},"datadog":true},
  deduplicate: true,
  fields: {} as { type: 'admin' | 'user' },
} as const

export const mooseOpenedUserFeedbackForm = {
  id: 'moose_opened_user_feedback_form',
  name: 'Opened User Feedback Form',
  contexts: ["moose"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as {},
} as const

export const mooseSettingAdded = {
  id: 'moose_setting_added',
  name: 'Added a Setting',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["note_type","context","note_button_label"]},"datadog":true},
  deduplicate: false,
  fields: {} as { note_type: string; context: 'admin_onboarding' | 'user_onboarding' | 'note_level_user_onboarding' | 'user_settings_page' | 'admin_settings_page' | 'max_chat'; note_button_label: string | null },
} as const

export const mooseSettingRemoved = {
  id: 'moose_setting_removed',
  name: 'Removed a Setting',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["note_type","context","note_button_label"]},"datadog":true},
  deduplicate: false,
  fields: {} as { note_type: string; context: 'admin_onboarding' | 'user_onboarding' | 'note_level_user_onboarding' | 'user_settings_page' | 'admin_settings_page' | 'max_chat'; note_button_label: string | null },
} as const

export const mooseSubmittedUserFeedbackForm = {
  id: 'moose_submitted_user_feedback_form',
  name: 'Submitted User Feedback Form',
  contexts: ["moose"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as {},
} as const

export const mooseUserOnboardingPromptsSaved = {
  id: 'moose_user_onboarding_prompts_saved',
  name: 'User Onboarding - Prompts Saved',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["note_type"]},"datadog":true},
  deduplicate: false,
  fields: {} as { note_type: string },
} as const

export const mooseUserOnboardingPromptsShown = {
  id: 'moose_user_onboarding_prompts_shown',
  name: 'User Onboarding - Prompts Shown',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["note_type"]},"datadog":true},
  deduplicate: false,
  fields: {} as { note_type: string },
} as const

export const noteDisplayed = {
  id: 'note_displayed',
  name: 'Note Displayed',
  contexts: ["arc"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { is_most_recent_note: boolean },
} as const

export const noteEditorLoaded = {
  id: 'note_editor_loaded',
  name: 'Note Editor Loaded',
  contexts: ["v1","v2","moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["duration_ms","is_refresh","is_cached","endpoint","app_entry_duration_ms","boot_duration_ms","patient_data_duration_ms"]},"datadog":true},
  deduplicate: false,
  fields: {} as { duration_ms: number; is_refresh: boolean; is_cached: boolean | null; endpoint: 'document' | 'patient-load' | null; app_entry_duration_ms: number | null; boot_duration_ms: number | null; patient_data_duration_ms: number | null },
} as const

export const overviewPageDisplayed = {
  id: 'overview_page_displayed',
  name: 'Overview Page Displayed',
  contexts: ["arc"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { full_load_duration_ms: number },
} as const

export const patientDetailPageDisplayed = {
  id: 'patient_detail_page_displayed',
  name: 'Patient Detail Page Displayed',
  contexts: ["arc"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { full_load_duration_ms: number; person_id: string; upgrade_available: boolean },
} as const

export const patientLoadTimeout = {
  id: 'patient_load_timeout',
  name: 'Patient Load Timeout',
  contexts: ["v1","v2","moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["is_refresh","endpoint"]},"datadog":true},
  deduplicate: false,
  fields: {} as { is_refresh: boolean; endpoint: 'document' | 'patient-load' },
} as const

export const patientSearchSubmitted = {
  id: 'patient_search_submitted',
  name: 'Patient Search Submitted',
  contexts: ["arc"] as const,
  backends: {"amplitude":{"nonPHIKeys":["search_text_length","total_count"]},"datadog":true},
  deduplicate: false,
  fields: {} as { text: string; search_text_length: number; total_count: number },
} as const

export const patientsPageDisplayed = {
  id: 'patients_page_displayed',
  name: 'Patients Page Displayed',
  contexts: ["arc"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { full_load_duration_ms: number; source: 'primary_navigation' | 'patient_detail' | 'direct'; count_patients_loaded: number; total_count: number; page_number: number; from: string; to: string },
} as const

export const patientsPageSwitched = {
  id: 'patients_page_switched',
  name: 'Patients Page Switched',
  contexts: ["arc"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { origin_page: number; destination_page: number },
} as const

export const redo = {
  id: 'redo',
  name: 'Redo',
  contexts: ["v1","v2"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as {},
} as const

export const refreshClicked = {
  id: 'refresh_clicked',
  name: 'Refresh Clicked',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["page","previous_data_staleness_ms"]},"datadog":true},
  deduplicate: false,
  fields: {} as { page: 'landing' | 'workspace'; previous_data_staleness_ms: number | null },
} as const

export const refreshCompleted = {
  id: 'refresh_completed',
  name: 'Refresh Completed',
  contexts: ["moose"] as const,
  backends: {"amplitude":{"nonPHIKeys":["page","duration_ms","outcome","previous_data_staleness_ms","is_cached"]},"datadog":true},
  deduplicate: false,
  fields: {} as { page: 'landing' | 'workspace'; duration_ms: number; outcome: 'success' | 'error'; previous_data_staleness_ms: number | null; is_cached: boolean },
} as const

export const timeWindowApplied = {
  id: 'time_window_applied',
  name: 'Time Window Applied',
  contexts: ["arc"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as { page: 'overview' | 'patients' | 'clinicians'; from: string; to: string; day_count: number; preset: 'last_30_days_of_billing_data' | 'last_30_days' | 'last_90_days' | 'this_quarter' | 'previous_quarter' | 'year_to_date' | null; previous_from: string; previous_to: string; previous_day_count: number; previous_preset: 'last_30_days_of_billing_data' | 'last_30_days' | 'last_90_days' | 'this_quarter' | 'previous_quarter' | 'year_to_date' | null },
} as const

export const underline = {
  id: 'underline',
  name: 'Underline',
  contexts: ["v1","v2"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as {},
} as const

export const undo = {
  id: 'undo',
  name: 'Undo',
  contexts: ["v1","v2"] as const,
  backends: {"amplitude":true,"datadog":true},
  deduplicate: false,
  fields: {} as {},
} as const

export const events = {
  bold,
  clinicianSearchSubmitted,
  cliniciansPageDisplayed,
  cliniciansPageSwitched,
  conditionDetailDisplayed,
  conditionsCopied,
  conditionsDisplayed,
  displayedColumnsChanged,
  filterChanged,
  firstUserInteractionRecorded,
  formatNote,
  italic,
  mooseChatAiEditedNote,
  mooseChatAiResponded,
  mooseChatCopiedAiResponse,
  mooseChatDislikedAiResponse,
  mooseChatLikedAiResponse,
  mooseChatSettingsEditCanceled,
  mooseChatSettingsEditCompleted,
  mooseChatUserPrompted,
  mooseCitationHovered,
  mooseDefaultSettingEdited,
  mooseGlobalSettingEdited,
  mooseHomepageButtonClicked,
  mooseLandingDisplayed,
  mooseMaxChatDataReady,
  mooseNoteAnalyzed,
  mooseNoteGenerationCompleted,
  mooseNoteLevelOnboardingRegeneratedNote,
  mooseNoteLevelOnboardingSaved,
  mooseNoteLevelOnboardingStarted,
  mooseNoteStreamTruncated,
  mooseOldVersionClicked,
  mooseOnboardingCompleted,
  mooseOnboardingStarted,
  mooseOpenedUserFeedbackForm,
  mooseSettingAdded,
  mooseSettingRemoved,
  mooseSubmittedUserFeedbackForm,
  mooseUserOnboardingPromptsSaved,
  mooseUserOnboardingPromptsShown,
  noteDisplayed,
  noteEditorLoaded,
  overviewPageDisplayed,
  patientDetailPageDisplayed,
  patientLoadTimeout,
  patientSearchSubmitted,
  patientsPageDisplayed,
  patientsPageSwitched,
  redo,
  refreshClicked,
  refreshCompleted,
  timeWindowApplied,
  underline,
  undo,
} as const
